<template>
  <div class="custom-cropper">
    <img id="image" :src="imageToCrop">
    <div class="slidecontainer">
      <div class="minus-icon" @keydown="ariaClick" role="button" tabindex="0" @click="lessZoom(10)" id="minusButton"></div>
      <input type="range" @keydown="manageKeyboardSlide($event)" :min="minSlideZoom" :max="maxSlideZoom" :value="zoomLevel" class="slider" id="myRange" tabindex="0" @change="manualZoom">
      <div class="plus-icon" @keydown="ariaClick" role="button" tabindex="0" @click="moreZoom(10)"></div>
    </div>
  </div>
</template>

<script>
import oneUtils from "../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

const slideZoomCropperZoomRatio = 100;

export default {
  name: "Cropper",
  mixins:[oneUtils.accessibilityMixin],
  data: () => ({
    imgCropped:null,
    zoomLevel:0,
    cropper:null,
    minSlideZoom:-30,
    maxSlideZoom:100,
  }),
  props: {
    imageToCrop: String,
    triggerLoadImage: Boolean
  },
  methods: {
    manageKeyboardSlide($event){
      this.ariaSlider($event, ()=>{this.lessZoom(10)}, ()=>{this.moreZoom(10)})
    },
    moreZoom(z){
      if(this.zoomLevel<this.maxSlideZoom){
        this.zoomLevel = this.zoomLevel+z;
        this.cropper.zoom(z/slideZoomCropperZoomRatio);
      }
    },
    lessZoom(z){
      if(this.zoomLevel>this.minSlideZoom){
        this.zoomLevel = this.zoomLevel-z;
        this.cropper.zoom(-z/slideZoomCropperZoomRatio);
      }
    },
    manualZoom(e){
      if(e.target.value<this.zoomLevel){
        while(e.target.value<this.zoomLevel){
          this.lessZoom(1);
        }
      }else{
        while(e.target.value>this.zoomLevel){
          this.moreZoom(1);
        }
      }
    },
    getCroppedImg(cropper){
      const dataUrl = cropper.getCroppedCanvas({ 
        minWidth: 100,
        minHeight: 100
      }).toDataURL("image/jpg");

      this.imgCropped = cropper.getCroppedCanvas({ 
        minWidth: 100,
        minHeight: 100
      }).toBlob((img)=>{
        // if(dimension>(4,9*1024*1024)){ //5MB
        //   this.$emit('dimensionAreTooBig');
        // }else{
          this.$emit('imgCropped',img);
        // }
      },'image/jpeg');
     
    },
    showError(){
      this.dimensionAreTooBig = true;
    }
  },
  watch: {
    triggerLoadImage(newVal, oldVal) {
      this.getCroppedImg(document.getElementById('image')?.cropper);
    }
  },
  async mounted(){
    const awaitImport = await import('cropperjs');
    const Cropper = (awaitImport).default;
    await import('cropperjs/dist/cropper.css');

    this.cropper = new Cropper(document.getElementById('image'), {
      aspectRatio: 1,
      autoCrop: false,
      viewMode:1,
      cropBoxMovable: false,
      cropBoxResizable: false,
      dragMode:'move',
      guides: false,
      center:false,
      highlight:false,
      background:false,
      maxHeight:10,
      zoomOnTouch:false,
      zoomOnWheel:false,
      restore: false,
      ready: function(e) {
        this.cropper.crop();
        this.cropper.zoom(this.zoomLevel/slideZoomCropperZoomRatio);
      }.bind(this),
      cropend :function(e){}.bind(this),
      zoom :function(e){
        const target = e.currentTarget;
      }.bind(this)
    });

    document.querySelector('.custom-cropper').onkeydown = function (event) {
      const e = event || window.event;
      switch (e.key) {
        case 'ArrowLeft':
        case 'Left':
          e.preventDefault();
          this.cropper.move(-1, 0);
          break;

        case 'ArrowUp':
        case 'Up':
          e.preventDefault();
          this.cropper.move(0, -1);
          break;

        case 'ArrowRight':
        case 'Right':
          e.preventDefault();
          this.cropper.move(1, 0);
          break;

        case 'ArrowDown':
        case 'Down':
          e.preventDefault();
          this.cropper.move(0, 1);
          break;
        default :
          break;
      }
    }.bind(this);
    document.querySelector('#minusButton').focus();
  }
};
</script>

<style lang="scss">
.custom-cropper{
  *{
    outline-offset: 0px !important;
  }
  max-width: 100%;
  img {
    display: block;
    max-width: 100%;
    height: 30vh;
  }
  .cropper-crop-box{
    border-radius:50%;
  }
  .cropper-view-box{
    border-radius:50%;
    outline: transparent;
  }
  .cropper-modal{
    background-color: white;
    opacity: 0.5;
  }

  .slidecontainer {
    width: 100%; /* Width of the outside container */
    margin-top: 25px;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /* The slider itself */
  .slider {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 80%; /* Full-width */
    height: 4px; /* Specified height */
    background: $barGrey; /* Grey background */
    -webkit-transition: .2s; /* 0.2 seconds transition on hover */
    transition: opacity .2s;

    &:hover {
      cursor: pointer;
    }

    &::-webkit-slider-runnable-track {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }

  .minus-icon{
    &:hover{
      outline: auto;
    }
    width: 35px;
    height: 35px;
    background-image: url("~@/assets/default/light/minus-default-light.svg");
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .plus-icon{
    &:hover{
      outline: auto;
    }
    width: 35px;
    height: 35px;
    background-image: url("~@/assets/default/light/plus-default-light.svg");
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }


  /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
  .slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 12px; /* Set a specific slider handle width */
    height: 12px; /* Slider handle height */
    background: $grey4; /* Green background */
    border-radius: 50%;
    cursor: pointer; /* Cursor on hover */
  }

  .slider::-moz-range-thumb {
    width: 12px; /* Set a specific slider handle width */
    height: 12px; /* Slider handle height */
    background: $grey4; /* Green background */
    border-radius: 50%;
    cursor: pointer; /* Cursor on hover */
  }

}
.__d{
  .custom-cropper{

    .minus-icon{
      background-image: url("~@/assets/default/dark/minus-default-dark.svg");
    }

    .plus-icon{
      background-image: url("~@/assets/default/dark/plus-default-dark.svg");
    }
  }
}
</style>
